import React from 'react';
import Log from "../components/Log/Log";

const Profil = () => {
    return (
        <div>
            <Log signin={false}  signup={true}/>
        </div>
    );
};

export default Profil;